export const state = {
  tasks: {},
};

export const getters = {};

export const mutations = {
  ADD_TASK(store, {id, modal}) {
    Object.assign(store.tasks, {[id]: {modal}});
  },
};

export const actions = {
  addTask({commit}, payload) {
    commit('ADD_TASK', payload);
  },
};
